import React from 'react';
import Button from '../../Buttons/Button';
import {
  ContentContainer,
  AdminAvatar,
  MainContainer,
  Description,
  ButtonContainer,
  styles,
} from './styles';
import strings from '../../../../localization';
import { getCurrentTheme } from '../../../../templates';
import { Text } from '../../../ReusableComponents';

const Error = ({ onPress, params }) => {
  const currentTheme = getCurrentTheme();
  return (
    <ContentContainer>
      <AdminAvatar source={{ uri: 'round_logo' }} resizeMode="contain" />
      <MainContainer>
        <Text
          style={[
            styles.title,
            {
              color: currentTheme.colors.secondaryLight,
            },
          ]}
        >
          {params.title}
        </Text>

        <Description>{params.subtitle}</Description>
        <ButtonContainer>
          <Button title={strings.common.ok} onPress={onPress} />
        </ButtonContainer>
      </MainContainer>
    </ContentContainer>
  );
};

export default Error;
